import { apiKeys, apiMethods, apiStatuses, apiUrls } from '@/store/api/constants';
import { clearData, fetchData } from '@/store/slices/fetch-slice';
import { getData, getStatus } from '@/store/slices/helpers/helpers';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

function useGetPlantMasterByDivision(division) {
  const dispatch = useDispatch();
  const state = useSelector((store) => store);

  const getPlantsByDivisionData = 
    getData(state, apiKeys.plantListByDivision(division), []);
  const getPlantsByDivisionStatus = 
    getStatus(state, apiKeys.plantListByDivision(division), '');
  const getPlantsByDivisionLoading = 
    apiStatuses.pending === getPlantsByDivisionStatus;


  const getPlantsByDivision = useCallback(
    (inputId) => {
      dispatch(
        fetchData({
          url: apiUrls.plantList,
          method: apiMethods.POST,
          key: apiKeys.plantListByDivision(division),
          body: inputId
        })
      );
    },
    [division, dispatch]
  );

  const getPlantsByDivisionOptions = useMemo(() => {
    return getPlantsByDivisionData.map(({ plantId, plantName }) => ({
      id: plantId,
      label: plantName
    }));
  }, [getPlantsByDivisionData]);

  useEffect(
    () => () => {
      dispatch(clearData({ key: [apiKeys.plantListByDivision(division)] }));
    },
    [division, dispatch]
  );

  return useMemo(
    () => ({
      getPlantsByDivisionData,
      getPlantsByDivisionStatus,
      getPlantsByDivision,
      getPlantsByDivisionOptions,
      getPlantsByDivisionLoading
    }),

    [
      getPlantsByDivisionData,
      getPlantsByDivisionStatus,
      getPlantsByDivision,
      getPlantsByDivisionOptions,
      getPlantsByDivisionLoading
    ]
  );
}

export default useGetPlantMasterByDivision;
